/**
 * Point d’entrée du bundle web.
 *
 * L’import de `./i18n` doit précéder le premier rendu : c’est lui qui initialise i18next de façon
 * synchrone avec les catalogues FR/EN déjà embarqués.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import './i18n';
// Polices servies par le bundle (OFL) : aucune requête vers un CDN tiers, rien à déclarer en cookies.
import '@fontsource-variable/eczar';
import '@fontsource-variable/atkinson-hyperlegible-next';
import './styles/tokens.css';
import './styles/global.css';
import './styles/app.css';
import './styles/jeu.css';
import './styles/invitation-paysage.css';

const racine = document.getElementById('racine');

if (racine === null) {
  // Erreur de montage (index.html incomplet) : message technique, jamais affiché au joueur.
  throw new Error('Élément racine #racine introuvable dans index.html');
}

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
